import * as React from 'react';
import { DialogContent } from '@material-ui/core';
import { PageAttributeProps } from '../multi-page-modal/types';
import { useFocusImport } from './use-focus-import';
import { JsonFileImporter } from '../../file-importer/json-file-importer';
import { useFocusFileValidator } from '../../file-importer/validators/use-focus-file-validator';
import { focusMapper } from '../../file-importer/mappers/focus-json-mapper';
import { Typography } from '@catapultsports/referee-react';
import { useTranslations } from 'i18n';
import { useGetDeepActivity } from 'api';
import { useEffect, useState } from 'react';
import { RadioButton } from '../../../reporting/components/radio-button/radio-button';
import styles from './focus-import.module.css';
import { FocusFile } from '../../file-importer/types';
import { AlignPeriodsScreen } from './content/align-periods-screen';

const TACTICAL_OPTION = 'tactical';
const ATHLETE_OPTION = 'athlete';
export const StartupPageModal: React.FC<PageAttributeProps> = (props) => {
    const { setSteps } = props;
    const { activityId, setFocusFile } = useFocusImport();
    const { data } = useGetDeepActivity(activityId);
    const validator = useFocusFileValidator();
    const { __ } = useTranslations();

    const [selectedOption, setSelectedOption] = useState<string>();
    const [disabled, setDisabled] = useState(true);
    /**
     *  update steps based on selection
     */
    useEffect(() => {
        if (selectedOption) {
            if (selectedOption === TACTICAL_OPTION) {
                setSteps?.([<StartupPageModal key="demo-page" />, <AlignPeriodsScreen key={'step2'} />]);
            }
            if (selectedOption === ATHLETE_OPTION) {
                setSteps?.([<StartupPageModal key="demo-page" />, <AlignPeriodsScreen key={'step2'} />]);
            }
        } else {
            setSteps?.([<StartupPageModal key="demo-page" setSteps={setSteps} activityId={activityId} />]);
        }
    }, [setSteps, selectedOption, activityId]);

    return (
        <DialogContent>
            <div className={styles['start-page-body']}>
                <div>
                    <Typography variant="heading-2">
                        {__('smt_importer.import_heading', { productName: 'Focus' })}
                    </Typography>
                    <Typography variant="heading-5">
                        {__('fiba.openfield_act')}: {data?.[0]?.name}
                    </Typography>
                </div>
                <div className={styles['import-input-wrapper']}>
                    <JsonFileImporter
                        fileValidator={validator}
                        json_mapper={focusMapper}
                        productName={'Focus'}
                        setData={(parsedData: FocusFile | undefined) => {
                            if (!parsedData) {
                                setSelectedOption(undefined);
                            } else {
                                setFocusFile(parsedData);
                            }
                            setDisabled(!parsedData);
                        }}
                    />
                    <Typography variant="body-1">{__('smt_importer.initial_import_prompt')}</Typography>
                </div>
                <div>
                    <RadioButton
                        label={__('smt_importer.focus_tactical_option_label')}
                        onChange={(event) => {
                            setSelectedOption(event.target.value);
                        }}
                        value={TACTICAL_OPTION}
                        isChecked={selectedOption === TACTICAL_OPTION}
                        name={'annotation_focus'}
                        description={__('smt_importer.focus_tactical_option_desc')}
                        disabled={disabled}
                    />
                    <RadioButton
                        label={__('smt_importer.focus_athlete_option_label')}
                        onChange={(event) => {
                            setSelectedOption(event.target.value);
                        }}
                        value={ATHLETE_OPTION}
                        isChecked={selectedOption === ATHLETE_OPTION}
                        name={'annotation_focus'}
                        description={__('smt_importer.focus_athlete_option_desc')}
                        disabled={disabled}
                    />
                </div>
            </div>
        </DialogContent>
    );
};
